module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-miguel-a-padrinan-small-44ba6d17488eb1b683d85eba4d779e69.jpg";